import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex } from "@chakra-ui/react";
import { getLocale } from "src/utils/locale";
import { Subtitle, BodyText2 } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as ShareIcon } from "src/icons/share-people.svg";
import Menu from "./MonitoringItemMenu";
import time from "src/utils/time";

function getFormattedMonitoringDate(startDateObj, t) {
  const now = time();
  const currentYear = now.year();
  const currentDayOfYear = now.dayOfYear();
  const isFromThisYear = startDateObj.year() === currentYear;
  const isFromToday = startDateObj.dayOfYear() === currentDayOfYear;
  const isFromYeasterday = startDateObj.dayOfYear() === currentDayOfYear - 1;

  let dateTimeOptions = {
    month: "long",
    day: "numeric",
    weekday: "long"
  };

  let result;
  if (isFromThisYear && isFromToday) {
    dateTimeOptions = {
      weekday: "long"
    };
    result = t("activityLog.today");
  } else if (isFromThisYear && isFromYeasterday) {
    result = t("activityLog.yesterday");
  } else {
    const dateTimeFormat = new Intl.DateTimeFormat(
      getLocale(startDateObj),
      dateTimeOptions
    );
    result = dateTimeFormat.format(startDateObj);
  }
  return result;
}

function getFormattedMonitoringDuration(startDateObj, duration) {
  const startTime = startDateObj.format("LT");

  const endTime = startDateObj.add(duration).format("LT");

  const timeDuration = time.duration(duration);
  let monitoringTime = timeDuration.format("h _ m _");
  if (timeDuration.asSeconds() < 60) {
    monitoringTime = timeDuration.format("s _");
  }

  return `${startTime} - ${endTime} · ${monitoringTime}`;
}

export default function MonitoringItem({
  startDate,
  duration,
  onSelect,
  isSelected,
  onDelete,
  isShared
}) {
  const { t } = useTranslation();
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [isHovered, setisHovered] = useState(false);

  const startDateObj = time(startDate);
  const monitoringDate = getFormattedMonitoringDate(startDateObj, t);
  const monitoringDuration = getFormattedMonitoringDuration(
    startDateObj,
    duration
  );
  return (
    <Box
      onClick={onSelect}
      width="100%"
      p="8px 16px"
      position="relative"
      borderRadius="12px"
      bg={isSelected ? "primaryLight" : "inherit"}
      onMouseEnter={() => setisHovered(true)}
      onMouseLeave={() => setisHovered(false)}
    >
      <Flex alignItems="center">
        <Subtitle color="highEmphasis">{monitoringDate}</Subtitle>
        {isShared && (
          <SvgContainer
            icon={ShareIcon}
            fill="mediumEmphasis"
            size="16px"
            ml="2px"
          />
        )}
      </Flex>
      <BodyText2 mt="4px" color="mediumEmphasis">
        {monitoringDuration}
      </BodyText2>
      <Box position="absolute" top="8px" right="8px">
        {isHovered ? (
          <Menu
            isOpen={isMenuOpened}
            onDelete={onDelete}
            onClose={() => setIsMenuOpened(false)}
            onOpen={() => setIsMenuOpened(true)}
          />
        ) : null}
      </Box>
    </Box>
  );
}
